import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22b1aece"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "categories-tree-item-content d-flex align-items-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas me-1 mb-1" }, "chevron_right", -1))
const _hoisted_3 = {
  key: 1,
  class: "name m-0 ps-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_RenameDPSubCategory = _resolveComponent("RenameDPSubCategory", true)!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", null, [
      _createElementVNode("td", {
        style: _normalizeStyle(_ctx.paddingStyle),
        class: "align-middle"
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.hasChildren)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                role: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleOpen(_ctx.categoriesTreeItem.code))),
                class: _normalizeClass([{ open: _ctx.isOpen }, "name d-flex align-items-center text-decoration-none lh-1"])
              }, [
                _hoisted_2,
                _createElementVNode("span", null, _toDisplayString(_ctx.categoriesTreeItem.name[_ctx.language]), 1)
              ], 2))
            : (_openBlock(), _createElementBlock("p", _hoisted_3, "  " + _toDisplayString(_ctx.categoriesTreeItem.name[_ctx.language]), 1))
        ])
      ], 4),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allLanguages, (lang) => {
        return (_openBlock(), _createElementBlock("td", {
          key: lang,
          class: "align-middle"
        }, [
          _createVNode(_component_InputText, {
            modelValue: _ctx.categoryName.custom_name[lang],
            "onUpdate:modelValue": ($event: any) => ((_ctx.categoryName.custom_name[lang]) = $event),
            modelModifiers: { trim: true },
            name: `name_${lang}_${_ctx.categoriesTreeItem.code}`,
            rules: "max:255",
            errors: _ctx.errors,
            onInput: _ctx.onNameChanged,
            class: "no-margin-bottom"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "errors", "onInput"])
        ]))
      }), 128))
    ]),
    (_ctx.hasChildren && _ctx.isOpen)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.categoriesTreeItem.subcategories, (subCategory) => {
          return (_openBlock(), _createBlock(_component_RenameDPSubCategory, {
            key: subCategory.code,
            "categories-tree-item": subCategory,
            level: (_ctx.level + 1),
            language: _ctx.language,
            allLanguages: _ctx.allLanguages,
            errors: _ctx.errors,
            categoryNames: _ctx.categoryNames,
            open: _ctx.open,
            onToggleOpen: _ctx.toggleOpen,
            onNameChanged: _ctx.onNameChanged
          }, null, 8, ["categories-tree-item", "level", "language", "allLanguages", "errors", "categoryNames", "open", "onToggleOpen", "onNameChanged"]))
        }), 128))
      : _createCommentVNode("", true)
  ], 64))
}